import React, { useState, useEffect, useCallback } from 'react';
import { GoogleMap, LoadScript, Marker, DirectionsRenderer } from '@react-google-maps/api';
import { GoogleKeys } from '../../../../config/google';

const MapView = ({ locationDetails }) => {
    const GoogleApiKey = GoogleKeys.GOOGLE_MAPS_API_KEY;
    const defaultLocation = { lat: 26.90695357562327, lng: 75.71685602070089 }; // Vaishali Nagar fallback
    const [userLocation, setUserLocation] = useState(null);
    const [directions, setDirections] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(false);

    useEffect(() => {
        try {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setUserLocation({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        });
                    },
                    (error) => {
                        console.error("Error fetching user location:", error);
                    }
                );
            } else {
                console.warn("Geolocation is not supported by this browser.");
            }
        } catch (error) {
            console.error("Unexpected error in fetching user location:", error);
        }
    }, []);

    const loadDirections = useCallback(() => {
        try {
            if (mapLoaded && userLocation && locationDetails?.lat && locationDetails?.lng && window.google) {
                const directionsService = new window.google.maps.DirectionsService();
                directionsService.route(
                    {
                        origin: userLocation,
                        destination: { lat: locationDetails.lat, lng: locationDetails.lng },
                        travelMode: window.google.maps.TravelMode.DRIVING,
                    },
                    (result, status) => {
                        if (status === window.google.maps.DirectionsStatus.OK) {
                            setDirections(result);
                        } else {
                            console.error("Directions request failed due to", status);
                        }
                    }
                );
            }
        } catch (error) {
            console.error("Error loading directions:", error);
        }
    }, [mapLoaded, userLocation, locationDetails]);

    useEffect(() => {
        try {
            loadDirections();
        } catch (error) {
            console.error("Unexpected error in useEffect:", error);
        }
    }, [mapLoaded, userLocation, locationDetails, loadDirections]);

    const mapCenter = locationDetails?.lat && locationDetails?.lng
        ? { lat: locationDetails.lat, lng: locationDetails.lng }
        : defaultLocation;

    const handleOpenGoogleMaps = () => {
        try {
            if (userLocation && locationDetails?.lat && locationDetails?.lng) {
                const url = `https://www.google.com/maps/dir/?api=1&origin=${userLocation.lat},${userLocation.lng}&destination=${locationDetails.lat},${locationDetails.lng}&travelmode=driving`;
                window.open(url, "_blank");
            } else {
                console.warn("User location or destination is missing.");
            }
        } catch (error) {
            console.error("Error opening Google Maps:", error);
        }
    };

    return (
        <div className='my-10'>
            <LoadScript
                googleMapsApiKey={GoogleApiKey}
                libraries={["places"]}
                onError={(error) => console.error("Error loading Google Maps script:", error)}
            >
                <GoogleMap
                    mapContainerStyle={{ width: '100%', height: '450px' }}
                    className="h-[300px] md:h-[450px] w-full rounded-lg shadow-lg"
                    center={mapCenter}
                    zoom={14}
                    onLoad={() => setMapLoaded(true)}
                    onError={(error) => console.error("Error loading Google Map:", error)}
                >
                    {userLocation && <Marker position={userLocation} label="You" />}
                    <Marker position={mapCenter} label="Property" />
                    {directions && <DirectionsRenderer directions={directions} />}
                </GoogleMap>
                <button
                onClick={handleOpenGoogleMaps}
                className="mt-4 px-5 py-3 text-white bg-blue-600 hover:bg-blue-700 transition-all duration-300 rounded-lg text-sm md:text-base font-semibold"
            >
                Open Directions in Google Maps
            </button>
            </LoadScript>
        </div>
    );
};

export default MapView;
